import { createApp } from 'vue'
import App from './App.vue'
import './styles/main.scss'  // Comment this out temporarily

createApp(App).mount('#app')